const TOUR_IDS = {
  calendar: {
    orgName: 'orgName',
    orgLogo: 'orgLogo',
    players: 'players',
    createEvent: 'createEvent',
  },
  rosterManagement: {
    playerList: 'playerList',
    search: 'searchPlayer',
    create: 'addPlayer',
  },
  createEvent: {
    form: 'my-form',
    date: 'startDate',
    time: 'startEndTime',
    team: 'teamField',
    opponent: 'opponentInfo',
    court: 'courtName',
  },
  createPractice: {
    form: 'my-form',
    date: 'practiceDate',
    time: 'practiceTime',
    team: 'practiceTeamField',
    location: 'practiceLocation',
    courtName: 'practiceCourtName',
  },
}

export default TOUR_IDS
